import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Search, UserPlus, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { inp } from "@/components/admin/AdminUi";

export function WoClientField({ value, onChange }) {
  const [q, setQ] = useState("");
  const [list, setList] = useState([]);
  const [creating, setCreating] = useState(false);
  const [nc, setNc] = useState({ first_name: "", last_name: "", company: "", phone: "", email: "" });
  const [busy, setBusy] = useState(false);
  const t = useRef();
  useEffect(() => {
    clearTimeout(t.current);
    if (q.trim().length < 2) return setList([]);
    t.current = setTimeout(() => api.get("/admin/work-orders/clients", { params: { q } }).then((r) => setList(r.data)).catch(() => setList([])), 200);
  }, [q]);
  const create = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/work-orders/clients", nc); onChange(data); setCreating(false); toast.success("Cliente salvato in anagrafica"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  if (value?.name && !creating) return (
    <div className="rounded-md border bg-slate-50 p-2.5 flex items-start gap-2" data-testid="wo-client-selected">
      <div className="flex-1 text-sm"><b>{value.name}</b> {value.source && <span className="text-[10px] px-1.5 py-0.5 rounded bg-brand-navy text-white uppercase">{value.source}</span>}
        <div className="text-xs text-slate-600">{[value.phone, value.email].filter(Boolean).join(" · ") || "nessun contatto"}</div></div>
      <button type="button" data-testid="wo-client-clear" onClick={() => onChange(null)} className="press p-1 text-slate-500"><X className="w-4 h-4" /></button>
    </div>
  );
  if (creating) {
    const f = (k, ph, cls = "") => <input data-testid={`wo-newclient-${k}`} placeholder={ph} value={nc[k]} onChange={(e) => setNc({ ...nc, [k]: e.target.value })} className={`${inp} ${cls}`} />;
    return (
      <div className="rounded-md border-2 border-dashed p-3 grid grid-cols-2 gap-2" data-testid="wo-newclient-form">
        {f("first_name", "Nome")}{f("last_name", "Cognome")}{f("company", "oppure Ragione sociale", "col-span-2")}{f("phone", "Telefono")}{f("email", "Email")}
        <div className="col-span-2 flex flex-wrap gap-2">
          <button type="button" data-testid="wo-newclient-save" onClick={create} disabled={busy} className="press h-9 px-3 rounded-md bg-brand-navy text-white text-sm font-semibold flex items-center gap-1">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Salva in anagrafica</button>
          <button type="button" data-testid="wo-newclient-once" onClick={() => { const n = nc.company || `${nc.first_name} ${nc.last_name}`.trim(); if (!n) return toast.error("Inserisci il nome"); onChange({ name: n, phone: nc.phone, email: nc.email }); setCreating(false); }} className="press h-9 px-3 rounded-md border text-sm font-semibold">Usa senza salvare</button>
          <button type="button" onClick={() => setCreating(false)} className="press h-9 px-3 text-sm text-slate-500">Annulla</button>
        </div>
      </div>
    );
  }
  return (
    <div className="relative">
      <Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
      <input data-testid="wo-client-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca per nome, telefono o email" className={`${inp} pl-9 pr-28`} />
      <button type="button" data-testid="wo-client-new" onClick={() => { setNc({ ...nc, first_name: q }); setCreating(true); }} className="press absolute right-1 top-1 h-8 px-2 rounded bg-brand-yellow text-brand-navy text-xs font-bold flex items-center gap-1"><UserPlus className="w-3.5 h-3.5" /> Nuovo</button>
      {list.length > 0 && (
        <div className="absolute z-30 mt-1 w-full rounded-md border bg-white shadow-lg max-h-64 overflow-y-auto" data-testid="wo-client-results">
          {list.map((c, i) => (
            <button type="button" key={i} data-testid={`wo-client-opt-${i}`} onClick={() => { onChange(c); setQ(""); }} className="w-full text-left px-3 py-2 hover:bg-slate-50 text-sm border-b last:border-0">
              <b>{c.name}</b> <span className="text-[10px] px-1 rounded bg-slate-100 uppercase">{c.source}</span><div className="text-xs text-slate-500">{[c.phone, c.email].filter(Boolean).join(" · ")}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
